module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/self2.webp";